<template>
  <div>
    <div class="form-choose-user-sign">
      <div class="docuemnt-information mb-3">
        <p class="title">
          Thông tin văn bản
        </p>
        <div class="card docuemnt-information__detail">
          <div>
            <p class="title-card">Tên văn bản</p>
          </div>
          <div>
            <p class="name-document">{{detailDocument.name}}</p>
          </div>
        </div>
      </div>
      <el-row :gutter="20" class="mb-3">
        <el-col :sm="24" :md="8" class="select-signer">
          <p class="title">
            Chọn người ký
          </p>
          <div class="card select-signer__detail">
            <div>
              <p class="title-card">Phòng ban</p>
            </div>
            <div class="mb-3">
              <el-select
                v-model="mData.department"
                filterable
                clearable
                placeholder="Chọn phòng ban"
                @change="changeDepartment(mData.department)"
              >
                <el-option
                  v-for="(item,index) in listDepartments"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <p class="title-card">
                Người ký
              </p>
            </div>
            <div class="mb-2">
              <el-select
                filterable
                v-model="mData.user"
                placeholder="Chọn người ký"
                @change="selectSigner(mData.user)"
              >
                <el-option
                  v-for="(item,index) in listUserSelects"
                  :key="index"
                  :label="`${item.administrative_info.name.full_name} - ${getNamePositionInOption(item.id)}`"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
        <el-col :sm="24" :md="16" class="list-signer">
          <p class="title">
            Danh sách ký
          </p>
          <div :class="{
            'card list-signer__detail': true,
            'list-signer__detail--empty': !haveListSigners
          }">
            <draggable
              class="list-group"
              ghost-class="ghost"
              @start="dragging = true"
              v-bind="dragOptions"
              @end="endDrag()"
              :component-data="getComponentData()"
              handle=".movePosition"
            >
              <transition-group class="transition-group" type="transition" :name="!dragging ? 'flip-list' : null">
                <template
                  v-for="(item, index) in listSigners"
                >
                  <div
                    :key="item.key"
                    class="user-sign"
                    v-if="loadListSigners"
                  >
                    <div class="user-sign__detail mb-2">
                      <div class="user-index mr-1">
                        {{index + 1}}
                      </div>
                      <div class="user-infomation__block ml-3">
                        <div class="user-infomation">
                          <div class="user-sign__avatar mr-3">
                            <!-- <el-avatar
                              :size="45"
                              :src="ExtensionService.urlImg + item.user_avatar"
                            ></el-avatar> -->
                            <el-image
                              :src="ExtensionService.urlImg + item.user_avatar"
                              fit="cover"
                            />
                          </div>
                          <el-tooltip
                            class="item"
                            effect="light"
                            :content="
                              `${item.user_name} - ${getNamePosition(item.position_id)} - ${getNameDepartment(item.department_id)}`
                            "
                            placement="top-start"
                          >
                          <p
                            class="user-name"
                            >
                              {{item.user_name}} - {{getNamePosition(item.position_id)}} - {{getNameDepartment(item.department_id)}}
                            </p>
                          </el-tooltip>
                        </div>
                        <div class="list-type-sign mb-2">
                          <p class="title-card__sign mb-2">
                            Chọn phương thức ký:
                          </p>
                          <el-radio-group
                            v-model="item.sign_type"
                            @change="changeSignType(item)"
                          >
                            <el-radio :label="'NONE'">Chỉ ký</el-radio>
                            <el-radio :label="'WATERMARK'">Ký watermark</el-radio>
                            <el-radio :label="'IMAGE_SIGNED'">
                              Ký ảnh
                              <i
                                v-b-popover.hover.top="'Thay đổi chữ ký & vị trí ký'"
                                v-if="item.sign_type == 'IMAGE_SIGNED' && item.sign_image_id"
                                class="icon-change-position isax-edit-2"
                                @click="changePositonSign(item)"
                              ></i>
                            </el-radio>
                          </el-radio-group>
                        </div>
                      </div>
                      <div class="action-group">
                        <div
                          class="fake-button movePosition"
                          v-b-popover.hover.bottom="'Kéo để thay đổi vị trí'"
                        >
                          <i class="icon isax-arrow-3"></i>
                        </div>
                        <div
                          class="fake-button ml-3"
                          v-b-popover.hover.bottom="'Xóa'"
                          @click="removeSigner(item.user_id, item.department_id)"
                        >
                          <i class="icon isax-trash"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </transition-group>
            </draggable>
            <div v-if="!haveListSigners">
              <p class="title">Danh sách người ký đang trống! Vui lòng chọn người ký!</p>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="document-content">
        <p class="title mb-2">
          Nội dung văn bản
        </p>
        <iframe
          title="View FDF"
          width="100%"
          height="500px"
          frameborder="0"
          :src="urlFilePdf"
        ></iframe>
      </div>
    </div>
    <div class="button-group text-right">
      <el-button
        type="danger"
        plain
        @click="onCancelForm"
      >
        Hủy
      </el-button>
      <el-button
        type="primary"
        @click="onSubmitForm"
        :disabled="!haveListSigners"
      >
        Trình ký
      </el-button>
    </div>
    <DialogChoosePositionSign
      @close="closeDialogChoosePositionSign"
      @submitClose="submitCloseDialogChoosePositionSign"
      :dialogVisible="dialogVisible"
      :dataObject="dataObjectModal"
      :pdfFileId="detailDocument.unsigned_pdf_id"
    />
  </div>
</template>
<script>
import ExtensionService from '@/service/ExtensionService';
import MethodService from '@/service/MethodService';
import DraffDocumentAutoApi from '@/moduleApi/DraffDocumentAutoApi';
import DepartmentApi from '@/moduleApi/DepartmentApi';
import EmployeeApi from '@/moduleApi/EmployeeApi';
import PositionApi from '@/moduleApi/PositionApi'
import draggable from "vuedraggable";
import toastr from 'toastr';
import DialogChoosePositionSign from './DialogChoosePositionSign';
import DraffDocumentAutoModel from './DraffDocumentAutoModel';
export default {
  components: {
    draggable,
    DialogChoosePositionSign
  },
  data() {
    return {
      ExtensionService,
      urlFilePdf: '',
      mData: {
        department: undefined,
        user: undefined,
      },
      dataForm: MethodService.copyObject(DraffDocumentAutoModel.dataForm),
      detailDocument: {
        name: '',
        unsigned_pdf_id: undefined,
        signed_pdf_id: undefined,
      },
      listUserSelects: [],
      listDepartments: [],
      listPositions: [],
      listSigners: [],
      dragging: false,
      loadListSigners: true,
      radio: undefined,
      dialogVisible: false,
      dataObjectModal: {},
      haveListSigners: false,
      value: undefined,
      currentUser: MethodService.getCurrentUser(),
      handleChangeAtr: true
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 700,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    async initData() {
      let filter = {
        filters: "disabled!=true",
        sort: "name",
        fields: "id,name,code",
        limit: 999999,
      }
      const departmentApiRes = await DepartmentApi.list(filter);
      const positionApiRes = await PositionApi.list(filter);
      this.listDepartments = departmentApiRes.result;
      this.listPositions = positionApiRes.result;
    },
    async getDetailDocument(id) {
      this.listSigners = [];
      const draffDocumentAutoApiRes = await DraffDocumentAutoApi.findById(id);
      if (!draffDocumentAutoApiRes.result.signers) {
        draffDocumentAutoApiRes.result.signers = [];
      }
      this.dataForm = draffDocumentAutoApiRes.result;
      this.detailDocument = draffDocumentAutoApiRes.result;
      this.urlFilePdf =  ExtensionService.urlImg + (this.detailDocument.unsigned_pdf_id ? this.detailDocument.unsigned_pdf_id : '')
      let arrPromise = [];
      (this.detailDocument.signers || []).forEach(signer => {
        arrPromise.push(
          EmployeeApi.findById(signer.user_id)
        )
      });
      Promise.all(arrPromise).then(res => {
        if (this.detailDocument.signers && this.detailDocument.signers.length > 0) {
          this.detailDocument.signers.forEach((item,index) => {
            let employee = res[index].result
            this.listSigners.push({
              key: new Date().getTime(),
              user_id: employee.id,
              user_avatar: employee.image_id ? employee.image_id : employee.administrative_info.avatar_id,
              user_name: employee.administrative_info.name.full_name,
              sign_type: item.sign_type,
              sign_image_id: item.sign_image_id,
              position_id: item.position_id,
              department_id: item.department_id,
            });
          })
          this.checkHaveListSigners()
        }
      })
      let checkInside = (this.dataForm.readers || []).find(item => item.employee_id == this.currentUser.id)
      if (!checkInside) {
        if (!this.dataForm.readers) this.dataForm.readers = []
        this.dataForm.readers.push({
          employee_id: this.currentUser.id,
          read_at: new Date()
        })
        this.updateReaders(this.dataForm)
      }
    },
    updateReaders(dataForm) {
      try {
        DraffDocumentAutoApi.update(dataForm)
      } catch (error) {
        toastr.error('Có lỗi xảy ra, vui lòng thử lại!')
      }
    },
    getListUser(departmentId) {
      // let filter = `status!=DA_NGHI&job_info:elemMatch:department_id=${departmentId}`;
      return new Promise((resolve, reject) => {
        let promise = EmployeeApi.GetEmployeeHasSignPermission({
          department_id: departmentId
        })
        resolve(promise)
      })
    },
    changeDepartment(departmentId) {
      this.mData.user = undefined;
      this.listUserSelects = [];
      if (departmentId) {
        this.getListUser(departmentId).then(res => {
          if (res.result) {
            this.listUserSelects = res.result.employees ? res.result.employees : [];
          }

        })
      }
    },
    selectSigner(signerId) {
      if (this.checkExistSigner(signerId)) {
        toastr.info('Người ký đã tồn tại trong danh sách ký');
        this.mData.user = undefined;
        return
      }
      let dataInfoEmployee = this.getInforEmployeeWithDeparterment(signerId);
      this.listSigners.push({
        key: new Date().getTime(),
        user_id: dataInfoEmployee[0].id,
        user_avatar: dataInfoEmployee[0].image_id ? dataInfoEmployee[0].image_id : dataInfoEmployee[0].administrative_info.avatar_id,
        user_name: dataInfoEmployee[0].administrative_info.name.full_name,
        position_id: dataInfoEmployee[1].position_id,
        department_id: dataInfoEmployee[1].department_id,
        sign_type: 'NONE',
        sign_image_id: undefined,
        position: undefined
      });
      this.checkHaveListSigners();
      this.mData.user = undefined;
    },
    checkHaveListSigners() {
      if (this.listSigners.length > 0) {
        this.haveListSigners = true;
      } else {
        this.haveListSigners = false;
      }
    },
    getInforEmployeeWithDeparterment(userId) {
      let employee = this.listUserSelects.find(item => item.id == userId);
      let jobInfoEmployee = employee.job_info.find(item => item.department_id == this.mData.department);
      return [employee, jobInfoEmployee]
    },
    checkExistSigner(userId) {
      let exist = this.listSigners.find(item => {
        return item.user_id == userId && item.department_id == this.mData.department
      });
      return exist ? true : false;
    },
    getNameDepartment(departmentId) {
      let department = this.listDepartments.find(item => item.id == departmentId);
      return department && department.name ? department.name : '';
    },
    getNamePosition(positionId) {
      let position = this.listPositions.find(item => item.id == positionId);
      return position && position.name ? position.name : '';
    },
    getNamePositionInOption(userId) {
      let dataInfoEmployee = this.getInforEmployeeWithDeparterment(userId);
      if (dataInfoEmployee[1] && dataInfoEmployee[1].position_id) {
        return this.getNamePosition(dataInfoEmployee[1].position_id);
      }
      return '';
    },
    removeSigner(userId,departmentId) {
      this.listSigners = this.listSigners.filter(item => {
        return !((item.user_id == userId) && (item.department_id == departmentId))
      });
      this.getPreviewPdf();
      this.checkHaveListSigners();
    },
    openModal(item) {
      this.dataObjectModal = item;
      setTimeout(() => {
        this.dialogVisible = true;
      }, 100);
    },
    changeSignType(item) {
      if (item.sign_type == 'IMAGE_SIGNED') {
        this.openModal(item);
      }
      if (item.sign_type == 'WATERMARK') {
        let checkEmployeeHaveWatermarkSign = this.listSigners.filter(item => item.sign_type == 'WATERMARK');
        if (checkEmployeeHaveWatermarkSign && checkEmployeeHaveWatermarkSign.length > 1) {
          toastr.info('Chỉ được phép chọn 1 người ký watermark');
          item.sign_type = 'NONE';
          return;
        }
        this.getPreviewPdf();
      }
      if (item.sign_type == 'NONE') {
        this.getPreviewPdf();
      }
    },
    changePositonSign(item) {

      this.openModal(item);
    },
    //Button event
    onCancelForm() {
      this.$router.push({ name: 'Admin-DocumentDrafting-list' }).catch(err => { });
    },
    async onSubmitForm() {
      if (this.listSigners.length == 0) {
        toastr.error('Vui lòng chọn người ký');
        return;
      }
      this.detailDocument.signers = this.listSigners;
      let dataUpdate = MethodService.copyObject(this.detailDocument);
      dataUpdate.status = 'SIGN_WAITING';
      dataUpdate.signers.forEach((signer,index) => {
        if (index == 0) {
          signer.status = 'WAITING';
        } else {
          signer.status = 'NEW';
        }
      });
      // return
      try {
        // await DraffDocumentAutoApi.update(dataUpdate);
        const dataPush = {
          dda_id: this.dataForm.id,
          signers: dataUpdate.signers
        };
        await DraffDocumentAutoApi.requestForSign(dataPush);
        toastr.success('Trình ký văn bản thành công');
        this.$router.push({ name: 'Admin-DocumentDrafting-list' }).catch(err => { });
      } catch (error) {
        toastr.error('Trình ký văn bản thất bại');
      }

    },
    clearTypeSign(indexUserSigner) {
      this.listSigners[indexUserSigner].sign_type = 'NONE'
      this.listSigners[indexUserSigner].position = undefined
    },
    //Dialog event
    closeDialogChoosePositionSign(data) {
      //Check User này đã lưu chữ ký là ký ảnh hay chưa
      let signer = this.listSigners.find(item => item.user_id == data.userId && item.department_id == data.derpartmentId)
      let indexUserSigner = this.listSigners.findIndex(item => item.user_id == data.userId && item.department_id == data.derpartmentId)
      if (signer && !signer.sign_image_id) {
        this.clearTypeSign(indexUserSigner)
      } else {
        if (!signer) {
          this.clearTypeSign(indexUserSigner)
        }
        this.getPreviewPdf();
      }
      this.dialogVisible = false;
      this.dataObjectModal = {};
    },
    async submitCloseDialogChoosePositionSign(data) {
      this.getPreviewPdf();
      this.dialogVisible = false;
      this.dataObjectModal = {};
    },
    async getPreviewPdf() {
      if (this.listSigners.length == 0) {
        this.urlFilePdf = ExtensionService.urlImg + (this.detailDocument.unsigned_pdf_id ? this.detailDocument.unsigned_pdf_id : '');
        return;
      }
      let dataPreviewPdf = {
        unsigned_file_id : this.detailDocument.unsigned_pdf_id,
        signers: this.listSigners
      }
      const apiRes = await DraffDocumentAutoApi.ViewSignsOnPdf(dataPreviewPdf);
      if (apiRes && apiRes.result) {
        this.urlFilePdf = 'data:application/pdf;base64, ' +  apiRes.result.fileBase64;
      }
    },

    //draggable function
    endDrag() {
        if (this.handleChangeAtr) {
          return
        }
      setTimeout(() => {
        this.dragging = false;
        this.loadListSigners = false;
        if (!this.value) {
          this.loadListSigners = true;
          this.handleChangeAtr = true;
          return
        }
        const newArrListUser = MethodService.moveObjectInArray(
          this.listSigners,
          this.value.oldIndex,
          this.value.newIndex
        );
        this.listSigners = newArrListUser;
        setTimeout(() => {
          this.loadListSigners = true;
          this.handleChangeAtr = true;
        }, 10);
      }, 500);
    },
    handleChange(value) {
      this.value = value;
      this.handleChangeAtr = false;
    },
    getComponentData() {
      return {
        on: {
          change: this.handleChange,
        },
        attrs: {
          wrap: false,
        },
      };
    },
    //end draggable function
  },
  created() {
    this.initData();
    if (this.$route.params.id) {
      this.getDetailDocument(this.$route.params.id);
    }
  }
}
</script>
<style lang="scss" scoped>
iframe {
  height: 86vh;
}
.form-choose-user-sign {
  max-height: calc(100vh - 125px);
  padding: 20px 10px 0 25px;
  overflow-y: auto;
  .docuemnt-information__detail {
    &:hover {
      cursor: not-allowed;
    }
  }
}
.title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
}
::v-deep .card {
  border: 1px solid #5E9BBC;
  border-radius: 10px;
  padding: 10px 16px;
  min-height: 121px;
  .title-card {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 10px;
  }
  .title-card__sign {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }
  .name-document {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }
  &.list-signer__detail {
    padding: 10px 5px 10px 16px;
    &.list-signer__detail--empty {
      align-items: center;
      justify-content: center;
    }
    .list-group {
      max-height: 400px;
      overflow-y: auto;
    }
  }
  .user-sign {
    .user-sign__detail {
      position: relative;
      border-bottom: 1px solid #5E9BBC;
      display: flex;
      align-items: flex-start;
      .user-index {
        // flex: 2 0 15px;
        margin-top: 10px;
        width: 51px;
        height: 21px;
        background: #5E9BBC;
        border-radius: 10px;
        text-align: center;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        color: #fff;
      }
      .user-infomation__block {
        // flex: 2 0 80%;
        margin-right: 10px;
        .user-infomation {
          display: flex;
          width: 100%;
          align-items: center;
          .user-sign__avatar {
            border: none;
            .el-avatar {
              img {
                width: 100%;
              }
            }
            .el-image {
              width: 45px;
              height: 45px;
              border-radius: 50%;
            }
          }
          .user-name {
            font-weight: 400;
            font-size: 16px;
            line-height: 20px;
            white-space: nowrap;
            width: 700px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .list-type-sign {
          .el-radio-group {
            .el-radio {
              margin-right: 40px;
              .el-radio__input {
                &.is-checked + .el-radio__label {
                  color: #5E9BBC;
                }
                &.is-checked {
                  .el-radio__inner {
                    border-color: #5E9BBC;
                    background: #fff;
                  }
                }
                .el-radio__inner {
                  width: 20px;
                  height: 20px;
                  border-color: #5E9BBC;
                  &:hover {
                    border-color: #5E9BBC;
                  }
                  &::after {
                    width: 15px;
                    height: 15px;
                    background-color: #5E9BBC;
                  }
                }
              }
              .el-radio__label {
                .icon-change-position {
                  color: #C8C34D;
                }
              }
            }
          }
        }
      }
      .action-group {
        display: flex;
        margin-left: 20px;
        .fake-button {
          width: 32px;
          height: 32px;
          background: rgba(0, 0, 0, 0.5);
          border-radius: 50%;
          position: relative;
          &:hover {
            cursor: pointer;
            background: #F56C6C;
          }
          &.movePosition {
            &:hover {
              cursor: move;
              background: #5E9BBC;
            }
          }
          .icon {
            position: absolute;
            top: 3px;
            left: 7px;
            &::before {
              color: #fff;
              font-size: 19px;
            }
          }
        }
      }
    }
  }
}
.button-group {
  padding: 10px 48px 10px 10px;
  height: 60px;
  // background: linear-gradient(356.91deg, #C7E3F2 0%, #FFFFFF 100%);
  box-shadow: 1px 0px 4px rgba(79, 138, 171, 0.25);
}
@media (max-width: 1800px) and (min-width: 1650px) {
  .user-sign {
    .user-sign__detail {
      .user-infomation__block {
        .user-infomation {
          .user-name {
            width: 600px !important;
          }
        }
      }
    }
  }
}
@media (max-width: 1649px) and (min-width: 1490px) {
  .user-sign {
    .user-sign__detail {
      .user-infomation__block {
        .user-infomation {
          .user-name {
            width: 500px !important;
          }
        }
      }
    }
  }
}
@media (max-width: 1489px) and (min-width: 1370px) {
  .user-sign {
    .user-sign__detail {
      .user-infomation__block {
        .user-infomation {
          .user-name {
            width: 400px !important;
          }
        }
      }
    }
  }
}
@media (max-width: 1369px) and (min-width: 1300px) {
  .user-sign {
    .user-sign__detail {
      .user-infomation__block {
        .user-infomation {
          .user-name {
            width: 350px !important;
          }
        }
      }
    }
  }
}
@media (max-width: 1299px) and (min-width: 1150px) {
  .user-sign {
    .user-sign__detail {
      .user-infomation__block {
        .user-infomation {
          .user-name {
            width: 250px !important;
          }
        }
      }
    }
  }
}
</style>
